<div class="mui-app-frame" *ngIf="(isFullscreen$ | async) === false; else fullscreen">
  <!-- Menu -->
  <mmu-main-menu
    *ngIf="user$ | async as user"
    [profileMenuItems]="profileMenuItems"
    [menuItems]="menuItems$ | async"
    [menuItemLabelTemplate]="translatedLabel"
    [appTitle]="'global.fullAppTitle' | translate"
    [collapseLabel]="'mainMenu.collapse' | translate"
    [userType]="user.type"
    [serviceLabel]="'mainMenu.serviceUserLabel' | translate"
  >
  </mmu-main-menu>

  <!-- Application -->
  <div
    class="mui-app-frame__app-container"
    [class]="{
      'has--full-sidebar': (menuCollapsed$ | async) === false,
      'has--collapsed-sidebar': (menuCollapsed$ | async)
    }">
    <ng-template #bannerTmpl>
      <mui-banner
        *ngIf="(online$ | async) === false"
        class="mui-app-frame__banner banner--offline"
        icon="exclamation-triangle"
        color="danger">
        {{ 'global.error.offline' | translate }}
      </mui-banner>
      <mmu-browser-support-banner>
        <!-- This component will hide itself when not required -->
      </mmu-browser-support-banner>
      <mmu-maintenance-banner>
        <!-- This component will hide itself when not required -->
      </mmu-maintenance-banner>
      <mmu-announcement-banner>
        <!-- This component will hide itself when not required -->
      </mmu-announcement-banner>
    </ng-template>

    <!-- Hero Area -->
    <mui-hero
      class="mui-app-frame__hero"
      [mainMenuService]="menuService"
      [pageTitle]="pageTitle$ | async"
      [banner]="bannerTmpl"
      [breadcrumbTemplate]="translatedLabel"></mui-hero>

    <!-- Main View Outlet -->
    <main class="mui-app-frame__page" [hidden]="resolvingRouteData$ | async">
      <ng-container *ngTemplateOutlet="outlet"></ng-container>
    </main>

    <!-- Loader Template Definition -->
    <ng-template [ngTemplateOutlet]="loader" *ngIf="resolvingRouteData$ | async"></ng-template>

    <!-- Footer -->
    <mmu-footer class="mui-app-frame__footer"></mmu-footer>
  </div>

  <div class="mui-overlay d-xl-none" *ngIf="mobileMenuOpen$ | async" [@overlay] (click)="menuService.open(false)"></div>
</div>

<ng-template #translatedLabel let-label>{{ label | translate }}</ng-template>

<ng-template #loader>
  <div class="mui-app-frame__outlet">
    <div class="container-fluid text-center">
      <mui-loader class="m-5"></mui-loader>
    </div>
  </div>
</ng-template>

<ng-template #fullscreen>
  <div class="mui-app-frame__fullscreen">
    <div class="mui-hero__fullscreen-header">
      <div class="mui-hero__header-logo mui-hero__logo-img mui-logo"></div>
      <button
        (click)="exitFullScreen()"
        mui-icon-btn
        appearance="secondary"
        icon="down-left-and-up-right-to-center"
        [title]="'global.btn.exitFullScreen' | translate"
        class="mui-hero__exit-fullscreen-btn"></button>
    </div>
    <ng-container [ngTemplateOutlet]="content?.fullscreenHeaderTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="outlet"></ng-container>
  </div>
</ng-template>

<ng-template #outlet>
  <router-outlet></router-outlet>
</ng-template>
